import React, { useState } from 'react';
import questions from './questions';

function App() {
  const [remaining, setRemaining] = useState([...questions]);
  const [current, setCurrent] = useState<string | null>(null);

  const shuffle = () => {
    if (remaining.length === 0) return;
    const idx = Math.floor(Math.random() * remaining.length);
    const next = remaining[idx];
    setCurrent(next);
    setRemaining(remaining.filter((q) => q !== next));
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <p style={styles.question}>{current ?? "Click shuffle to begin!"}</p>
        <button onClick={shuffle} style={styles.button} disabled={remaining.length === 0}>
          {remaining.length > 0 ? "Shuffle" : "All done!"}
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#121212',
    color: '#f5f5f5',
    fontFamily: 'sans-serif',
  },
  card: {
    background: '#1e1e1e',
    padding: '2rem',
    borderRadius: '1rem',
    boxShadow: '0 8px 24px rgba(0,0,0,0.5)',
    textAlign: 'center' as const,
    maxWidth: '600px',
  },
  question: {
    fontSize: '1.25rem',
    marginBottom: '1.5rem',
  },
  button: {
    padding: '0.75rem 1.5rem',
    fontSize: '1rem',
    background: '#3f51b5',
    color: 'white',
    border: 'none',
    borderRadius: '0.5rem',
    cursor: 'pointer',
    transition: 'background 0.2s',
  },
};

export default App;

